import React, { useState, useEffect } from "react";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, } from 'chart.js';
import { Line } from 'react-chartjs-2';
import axios from "axios";
import { useSelector } from "react-redux";
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);
const GradeMultilinechart = (props) => {
    const labels = [];
    const sections = {};
    const [Performancetrends, SetPerformancetrends] = useState();
    const items = useSelector((state) => state.userDetailsData.LoginDetails);
    const PerformanceTrendForGrade = async () => {
        SetPerformancetrends();
        await axios.get(process.env.REACT_APP_API_BASE_URL + `/TeachersDashboard/GetPerformanceTrendForGrade?Year=${props.Year}&AssessmentType=${props.AssessmentType}&SchoolId=${items.schoolId}&Grade=${props.Grade}&SubjectName=${props.SubjectName}`, { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
            .then((res) => {
                if (res.data[0].assessmentDate) {
                    SetPerformancetrends(res.data);
                } else {
                    SetPerformancetrends(process.env.REACT_APP_NODATAFOUND_Participated);
                }
            })
            .catch(err => console.log(err))
    };

    useEffect(() => {
        if (props.SubjectName) { PerformanceTrendForGrade(); }
    }, [props.SubjectName, props.Year, props.Grade, props.AssessmentType])


    if (Performancetrends?.[0]?.assessmentDate) {

        Performancetrends?.forEach(item => {
            if (!labels.includes(item.assessmentDate)) { labels.push(item.assessmentDate); }
            if (!sections[item.section]) { sections[item.section] = Array(labels.length).fill(null); }
        });

        Performancetrends?.forEach(item => {
            const index = labels.indexOf(item.assessmentDate);
            sections[item.section][index] = item.performancePercentage;
        });
    }
    const datasets = Object.keys(sections).map(section => ({
        label: `Section ${section}`,
        data: sections[section],
        backgroundColor: {
            A: '#3DA663',
            B: '#7C60BC',
            C: '#3B9ED7',
            D: '#F7C66A',
            X: '#A63D95',
        }[section] || '#000',
        borderColor: {
            A: '#3DA663',
            B: '#7C60BC',
            C: '#3B9ED7',
            D: '#F7C66A',
            X: '#A63D95',
        }[section] || '#000',
        barThickness: 40,
    }));

    const data = {
        labels: labels,
        datasets: datasets,
    };

    const options = {
        responsive: true,
        circular: true,
        animations: { tension: 0, },
        plugins: {
            legend: { position: 'bottom', labels: { usePointStyle: true, radius: "2", }, font: { size: 5, }, },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        let label = context.dataset.label || '';
                        if (label) { label += ': '; }
                        if (context.parsed.y !== null) { label += context.parsed.y + '%'; }
                        return label;
                    }
                }
            },
        },

        scales: {
            x: { stacked: false, offset: true, title: { display: true, text: 'Assessment Date' }, grid: { display: false, }, },
            y: { max: 100, stacked: false, title: { display: true, text: '% Marks' }, beginAtZero: true, }
        }
    };

    return (<>
        {Performancetrends?.[0]?.assessmentDate ? <Line options={options} data={data} ref={props.Ref} /> :
            <div className="ErrorMessage">{Performancetrends}</div>}
    </>
    )
};
export default GradeMultilinechart;